module.exports = __webpack_public_path__ + "img/light-Path 16 Copy@3x.54205e2c.png";